import Cookies from "js-cookie";
import {useEffect, useState} from "react";
import {AccountsError, useAuth} from "../components/auth/AuthContext";
import {MigrationAPI} from "../accounts-api/accounts-api";
import {getReturnUrl} from "../env/env";
import {User} from "../components/auth/types";

export type RequireAuthReturn = {
  loading: boolean;
  user?: User | null;
  error?: AccountsError;
  redirectTo?: string;
}

function isAuthenticatedWithOldAccounts() {
  return Cookies.get("wk_logged_in") === "1";
}

type MigrationStatus = "notMigrated" | "migrating" | "migrated";

export const useRequireAuth = (origin?: string): RequireAuthReturn => {
  const [status, setStatus] = useState<MigrationStatus>("notMigrated");
  const [migrationError, setMigrationError] = useState<AccountsError>();
  const {loading, user, error} = useAuth();
  useEffect(() => {
    if (status === "migrating") {
      MigrationAPI.migrateAccount()
      .then(() => setStatus("migrated"))
      .catch(err => {
        console.error(err);
        setMigrationError(err);
      });
    }
  }, [status]);

  if (loading) {
    return {loading};
  }
  if (migrationError) {
    return {loading, error: migrationError};
  }
  if (error) {
    return {loading, error};
  }

  if (user) {
    return {user, loading};
  }

  let redirectTo = "";
  if (isAuthenticatedWithOldAccounts()) {
    if (status === "migrated") {
      redirectTo = getReturnUrl(origin,"/accounts/reauthenticate?destination=settings");
      return {
        loading: false,
        redirectTo
      };
    }
    if (status === "notMigrated") {
      setStatus("migrating");
    }
    return {
      loading: true
    };
  }

  return {
    loading,
    error,
    user: user,
    redirectTo: getReturnUrl(origin),
  }
};
